import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./Airbnb.css";
import ServiceFooter from "../../ServiceFooter";
import { useState } from "react";
import { arKeyFeatures, arMarketData } from "./data";
import AirbnbKey from "./AirbnbKey";

const Airbnb = () => {
  const [activeTab, setActiveTab] = useState("guest");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const [activeKeyIndex, setActiveKeyIndex] = useState(0);

  const handleKeyShow = (index) => {
    setActiveKeyIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // market accordion
  const [activeMarketIndex, setActiveMarketIndex] = useState(0);

  const handleMarketShow = (index) => {
    setActiveMarketIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Airbnb Clone For Best Vacation Rental Script</title>

        <meta
          name="title"
          content="Airbnb Clone For Best Vacation Rental Script"
        />
        <meta
          name="description"
          content="Beleaf Airbnb clone offers a ready made solution to replicate the core features of Airbnb, allowing you to quickly and efficiently build a vacation rental business. Get free Quote"
        />

        <meta
          property="og:title"
          content="Airbnb Clone For Best Vacation Rental Script"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/airbnb-clone"
        />
      </Helmet>

      <main className="ar-main ">
        {/* hero */}
        <article className="ar-hero primary__landing__container ar-mb-80">
          {/* <video muted loop playsInline autoPlay className="sc-bk-video">
            <source
              src="https://res.cloudinary.com/dmjw7pe6k/video/upload/v1740717119/hero_ommumf.mp4"
              type="video/mp4"
            />
          </video> */}
          <div className="ar-hero-text">
            <h1 className="ar-hero-title">Airbnb Clone</h1>
            <p className="ar-hero-content">
              Build a Profitable Vacation Rental Marketplace with beleaf Airbnb
              clone script
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ar-hero-btn"
              >
                Get Free Consultation
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>

        {/* about */}
        <article className="ar-about primary__landing-content-container ar-mb-80">
          <div className="row mx-0 ar-about-row">
            <div className="col-lg-4 col-md-6">
              <h3 className="ar-subtitle-one">What Is an Airbnb Clone?</h3>
            </div>
            <div className="col-lg-8 col-md-6">
              <div className="ar-abt-content">
                <p>
                  <span>
                    Building a platform like Airbnb from scratch can be both
                    time-consuming and expensive. An Airbnb clone is a
                    custom-built vacation rental platform that mimics the core
                    functionalities of Airbnb, including property listings,
                    online booking, secure payments, and host-guest
                    interactions. With the right Airbnb clone development, you
                    can launch a feature-rich rental platform tailored to your
                    business needs.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* acd */}
        <article className="ar-acd primary__landing__container ar-mb-80">
          <div className="row mx-0 ar-acd-row">
            <div className="col-lg-6">
              <h3 className="ar-subtitle-one">Airbnb Clone Development</h3>

              <p className="ar-acd-content">
                The demand for vacation rental platforms is skyrocketing, with
                businesses looking to replicate successful models like Airbnb.{" "}
              </p>
              <p className="ar-acd-content">
                Developing an Airbnb clone is a smart way to enter the online
                rental marketplace without starting from scratch. By leveraging
                an Airbnb clone, you can create a fully functional platform that
                connects hosts and guests while offering a seamless booking
                experience.
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn ar-btn mt-4"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/Airbnb/acd.webp")}
                alt="Airbnb Clone"
              />
            </div>
          </div>
        </article>

        {/* needs */}
        <article className="ar-needs ar-mb-80">
          <div className="primary__landing__container">
            <h3 className="ar-subtitle-two text-center">
              Understanding <span className="ar-span">the User’s Needs</span>
            </h3>
            <p className="ar-needs-content">
              When thinking about building an Airbnb clone, it’s crucial to
              consider the needs of both guests and hosts. The success of your
              clone will depend on how well you cater to these needs.
            </p>

            <div className="ar-nd-btns-wrap">
              <button
                className={`ar-nd-btn ${activeTab === "guest" ? "active" : ""}`}
                onClick={() => handleTabChange("guest")}
              >
                Guest Perspective
              </button>
              <button
                className={`ar-nd-btn ${activeTab === "host" ? "active" : ""}`}
                onClick={() => handleTabChange("host")}
              >
                Host Perspective
              </button>
            </div>

            <div className="ar-want-wrap">
              <h6 className="ar-want-title">
                {activeTab === "guest"
                  ? " What Do Travelers Want?"
                  : " What Do Property Owners Need?"}
              </h6>

              <div className="row mx-0 ar-want-row g-4">
                {activeTab === "guest" ? (
                  <>
                    <div className="col-lg-4 col-md-6">
                      <div className="ar-want-card wt-one">
                        <div className="ar-wt-top">
                          <h4>Trust and Transparency</h4>
                          <p>
                            Travelers need to feel secure when booking their
                            stays. Features like guest reviews, clear property
                            descriptions, high-quality images, and transparent
                            pricing are key to building that trust.
                          </p>
                        </div>

                        <div className="ar-wt-bottom">
                          <h4>Trust and Transparency</h4>
                          <span>
                            <i className="fa-solid fa-plus"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="ar-want-card wt-two">
                        <div className="ar-wt-top">
                          <h4>Easy Navigation</h4>
                          <p>
                            A clean, intuitive design that allows users to
                            quickly search for properties based on criteria such
                            as location, price, amenities, and guest capacity is
                            essential. Travelers should feel at ease while
                            booking their next vacation.
                          </p>
                        </div>

                        <div className="ar-wt-bottom">
                          <h4>Easy Navigation</h4>
                          <span>
                            <i className="fa-solid fa-plus"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="ar-want-card wt-three">
                        <div className="ar-wt-top">
                          <h4>Instant Communication</h4>
                          <p>
                            Guests want a direct and simple way to communicate
                            with hosts before and during their stay. Instant
                            messaging, quick response systems, and automated
                            booking confirmations enhance convenience and
                            responsiveness.
                          </p>
                        </div>

                        <div className="ar-wt-bottom">
                          <h4>Instant Communication</h4>
                          <span>
                            <i className="fa-solid fa-plus"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-lg-4 col-md-6">
                      <div className="ar-want-card wt-four">
                        <div className="ar-wt-top">
                          <h4>Easy Listing Management</h4>
                          <p>
                            Hosts want an easy way to list their properties,
                            manage bookings, and track earnings. A user-friendly
                            dashboard and intuitive property management tools
                            are crucial.
                          </p>
                        </div>

                        <div className="ar-wt-bottom">
                          <h4>Easy Listing Management</h4>
                          <span>
                            <i className="fa-solid fa-plus"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="ar-want-card wt-five">
                        <div className="ar-wt-top">
                          <h4>Security and Payment Guarantees</h4>
                          <p>
                            Hosts also need to feel secure in their
                            transactions. Integrated payment systems, refundable
                            security deposits, and clear policies on
                            cancellations or damages help create a sense of
                            security.
                          </p>
                        </div>

                        <div className="ar-wt-bottom">
                          <h4>Security and Payment Guarantees</h4>
                          <span>
                            <i className="fa-solid fa-plus"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="ar-want-card wt-six">
                        <div className="ar-wt-top">
                          <h4>Effective Communication and Reviews</h4>
                          <p>
                            Just like guests, hosts rely on transparent
                            communication and reviews to determine if they
                            should accept a booking. A feature to track guest
                            reviews and ratings can enhance their trust and
                            decision-making process.
                          </p>
                        </div>

                        <div className="ar-wt-bottom">
                          <h4>Effective Communication and Reviews</h4>
                          <span>
                            <i className="fa-solid fa-plus"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </article>

        {/* better */}
        <article className="ar-better primary__landing-content-container ar-mb-80">
          <div className="row mx-0 ar-bt-row g-4">
            <div className="col-lg-4">
              <h3 className="ar-subtitle-one ar-better-title">
                A Better Airbnb Clone for a{" "}
                <span className="ar-span">Competitive Edge</span>{" "}
              </h3>
            </div>
            <div className="col-lg-8">
              <div className="ar-bt-card bt-two">
                <p className="ar-bt-card-content">
                  By understanding the unique needs of guests and hosts, you can
                  begin to add features that enhance the user experience. Your
                  Airbnb clone should aim to provide not only the standard
                  functionalities but also unique elements that will attract
                  users to your platform.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="row mx-0 ar-bt-row g-4">
            <div className="col-lg-3 col-md-6">
              <div className="ar-bt-card bt-one">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="ar-bt-btn"
                >
                  <span className="ar-bt-btn-txt">Know More</span>
                  <span className="ar-bt-btn-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
            <div className="col-lg-4 col-md-6"></div>
            <div className="col-lg-3 col-md-6">
              <div className="ar-bt-card bt-three">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="ar-bt-btn"
                >
                  <span className="ar-bt-btn-txt">Know More</span>
                  <span className="ar-bt-btn-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>

            <div className="col-lg-2 col-md-6">
              <div className="ar-bt-card bt-four">
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="ar-bt-btn ar-btn-four"
                >
                  <span className="ar-bt-btn-txt">Know More</span>
                  <span className="ar-bt-btn-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </div> */}
        </article>

        {/* key features */}
        <article className="ar-key primary__landing-content-container ar-mb-60">
          <div className="row mx-0 ar-key-row">
            <div className="col-lg-5">
              <h3 className="ar-subtitle-one">
                <span className="ar-span">Key Features </span>
                of an Airbnb Clone
              </h3>
              <p className="ar-key-content mt-3">
                A powerful Airbnb clone should include essential features that
                enhance user experience and business operations. Here are the
                must-have functionalities
              </p>
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn ar-btn mt-4"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>

            <div className="col-lg-7">
              <div className="ar-key-rgt">
                {arKeyFeatures.map((data, index) => {
                  return (
                    <AirbnbKey
                      key={data.id}
                      data={data}
                      showIndex={activeKeyIndex === index}
                      handleShow={() => handleKeyShow(index)}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </article>

        {/* revenue */}
        <article className="ar-revenue primary__landing__container ar-mb-100">
          <h3 className="ar-subtitle-one text-center ar-rev-title">
            <span className="ar-span">Revenue Models </span>
            for an Airbnb Clone
          </h3>

          <div className="ar-rev-card-wrap">
            <div className="ar-rev-card rev-one">
              <img
                src={require("../../../image/Airbnb/rev-img-one.webp")}
                alt="Airbnb Clone"
              />
              <h6>Commission Based Model</h6>
              <p>
                Charge a commission from hosts for every successful booking.
              </p>
            </div>
            <div className="ar-rev-card rev-two">
              <img
                src={require("../../../image/Airbnb/rev-img-two.webp")}
                alt="Airbnb Clone"
              />
              <h6>Subscription Plans</h6>
              <p>
                Offer premium plans for hosts to list their properties with
                additional benefits.
              </p>
            </div>
            <div className="ar-rev-card rev-three">
              <img
                src={require("../../../image/Airbnb/rev-img-three.webp")}
                alt="Airbnb Clone"
              />
              <h6>Featured Listings</h6>
              <p>
                Allow property owners to promote their listings through paid
                advertisements.
              </p>
            </div>
            <div className="ar-rev-card rev-four">
              <img
                src={require("../../../image/Airbnb/rev-img-four.webp")}
                alt="Airbnb Clone"
              />
              <h6>Service Fees</h6>
              <p>
                Charge service fees to guests for booking accommodations through
                the platform.
              </p>
            </div>
            <div className="ar-rev-card rev-five">
              <img
                src={require("../../../image/Airbnb/rev-img-five.webp")}
                alt="Airbnb Clone"
              />
              <h6>Advertisement Revenue</h6>
              <p>
                Generate income by displaying relevant ads from travel and
                hospitality brands.
              </p>
            </div>
          </div>

          <div className="row mx-0 ar-rev-row g-4">
            <div className="col-sm-6">
              <div className="ar-rev-card rev-one">
                <img
                  src={require("../../../image/Airbnb/rev-img-one.webp")}
                  alt="Airbnb Clone"
                />
                <h6>Commission Based Model</h6>
                <p>
                  Charge a commission from hosts for every successful booking.
                </p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="ar-rev-card rev-two">
                <img
                  src={require("../../../image/Airbnb/rev-img-two.webp")}
                  alt="Airbnb Clone"
                />
                <h6>Subscription Plans</h6>
                <p>
                  Offer premium plans for hosts to list their properties with
                  additional benefits.
                </p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="ar-rev-card rev-three">
                <img
                  src={require("../../../image/Airbnb/rev-img-three.webp")}
                  alt="Airbnb Clone"
                />
                <h6>Featured Listings</h6>
                <p>
                  Allow property owners to promote their listings through paid
                  advertisements.
                </p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="ar-rev-card rev-four">
                <img
                  src={require("../../../image/Airbnb/rev-img-four.webp")}
                  alt="Airbnb Clone"
                />
                <h6>Service Fees</h6>
                <p>
                  Charge service fees to guests for booking accommodations
                  through the platform.
                </p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="ar-rev-card rev-five">
                <img
                  src={require("../../../image/Airbnb/rev-img-five.webp")}
                  alt="Airbnb Clone"
                />
                <h6>Advertisement Revenue</h6>
                <p>
                  Generate income by displaying relevant ads from travel and
                  hospitality brands.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* adv features */}
        <article className="ar-features primary__landing-content-container ar-mb-100">
          <div className="row mx-0 ar-adv-row">
            <div className="col-lg-6">
              <h3 className="ar-subtitle-one">
                Advanced <span className="ar-span"> Features to Make</span> Your
                Airbnb Clone Stand Out
              </h3>
            </div>
            <div className="col-lg-1"></div>
            <div className="col-lg-5">
              <p className="ar-adv-content">
                To give your Airbnb clone a competitive edge, consider adding
                advanced features that improve user experience and increase
                platform appeal.
              </p>
            </div>
          </div>

          <div>
            <div className="ar-adv-gallery">
              <div className="ar-adv-box">
                <img
                  src={require("../../../image/Airbnb/adv-img-one.webp")}
                  alt="Airbnb Clone"
                />
                <span>
                  <div className="ar-adv-inner_box_content">
                    <h4>AI for Personalized Recommendations</h4>
                    <p>
                      AI can be used to enhance the guest experience by offering
                      personalized property recommendations based on previous
                      bookings, preferences, and location data.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="ar-adv-btn"
                    >
                      To Know More
                      <span className="mx-2 ">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </span>
              </div>
              <div className="ar-adv-box">
                <img
                  src={require("../../../image/Airbnb/adv-img-two.webp")}
                  alt="Airbnb Clone"
                />
                <span>
                  <div className="ar-adv-inner_box_content">
                    <h4>Blockchain for Transparency</h4>
                    <p>
                      Blockchain can be integrated to provide secure and
                      transparent transactions. Smart contracts can be used for
                      automatic payments and refunds, ensuring that both hosts
                      and guests are protected.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="ar-adv-btn"
                    >
                      To Know More
                      <span className="mx-2 ">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </span>
              </div>
              <div className="ar-adv-box">
                <img
                  src={require("../../../image/Airbnb/adv-img-three.webp")}
                  alt="Airbnb Clone"
                />
                <span>
                  <div className="ar-adv-inner_box_content">
                    <h4>Multi-Language and Multi-Currency Support</h4>
                    <p>
                      As vacation rental platforms go global, offering
                      multi-language and multi-currency support will expand your
                      platform’s reach. Users can view listings in their
                      preferred language and currency, improving their
                      experience.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="ar-adv-btn"
                    >
                      To Know More
                      <span className="mx-2 ">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </span>
              </div>
              <div className="ar-adv-box">
                <img
                  src={require("../../../image/Airbnb/adv-img-four.webp")}
                  alt="Airbnb Clone"
                />
                <span>
                  <div className="ar-adv-inner_box_content">
                    <h4>Virtual Tours</h4>
                    <p>
                      Integrating virtual tours or 360-degree views of
                      properties can increase engagement and help guests make
                      decisions without physically visiting the property.
                    </p>
                    <button
                      data-toggle="modal"
                      data-target="#myModal"
                      className="ar-adv-btn"
                    >
                      To Know More
                      <span className="mx-2 ">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </button>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </article>

        {/* market */}
        <article className="ar-market primary__landing__container ar-mb-100">
          <div className="row mx-0 ar-mk-row">
            <div className="col-xl-4 col-lg-5 col-md-6">
              <h3 className="ar-subtitle-one">
                How to <span className="ar-span">Market Your</span> Airbnb Clone
              </h3>
            </div>
            <div className="col-xl-3 col-lg-1 ar-mk-mob-none"></div>
            <div className="col-xl-5 col-lg-6 col-md-6">
              <p className="ar-mk-content">
                Once you’ve built your Airbnb clone, it’s time to attract guests
                and hosts. Here’s how to effectively market your platform.
              </p>
            </div>
          </div>

          <div className="row mx-0 ar-mk-row-two">
            <div className="col-lg-6">
              {arMarketData.map((data, index) => {
                return (
                  <div key={data.id} className="ar-mk-wrap">
                    <h3 className="ar-mk-wr-title">{data.title}</h3>
                    <div
                      className={`ar-mk-wr-btn ${
                        activeMarketIndex === index ? "d-none" : "d-flex"
                      }`}
                      onClick={() => handleMarketShow(index)}
                    >
                      <span>
                        <i className="fa-solid fa-plus"></i>
                      </span>
                      <span>{data.rdBtn}</span>
                    </div>
                    {activeMarketIndex === index && (
                      <p className="ar-mk-wr-content">{data.content}</p>
                    )}
                  </div>
                );
              })}
            </div>
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/Airbnb/market.webp")}
                alt="Airbnb Clone"
              />
            </div>
          </div>
        </article>

        {/* why choose */}
        <article className="ar-why-choose primary__landing__container">
          <div className="row mx-0 ar-why-row">
            <div className="col-lg-6">
              <h3 className="ar-subtitle-one">
                Why Choose a Professional Airbnb Clone Development Company?
              </h3>

              <p className="ar-acd-content">
                Hiring a professional Airbnb clone development company ensures a
                high-quality, scalable, and secure solution. Benefits of working
                with experts include{" "}
              </p>

              <div className="ar-ch-list">
                <span className="ar-ch-check">
                  <i className="fa-solid fa-check"></i>
                </span>
                <p>Custom-built solutions tailored to your business needs.</p>
              </div>
              <div className="ar-ch-list">
                <span className="ar-ch-check">
                  <i className="fa-solid fa-check"></i>
                </span>
                <p>Secure and scalable architecture.</p>
              </div>
              <div className="ar-ch-list">
                <span className="ar-ch-check">
                  <i className="fa-solid fa-check"></i>
                </span>
                <p>Ongoing technical support and maintenance.</p>
              </div>
              <div className="ar-ch-list">
                <span className="ar-ch-check">
                  <i className="fa-solid fa-check"></i>
                </span>
                <p>
                  Integration of AI, Crypto Payment gateway, and analytics
                  tools.
                </p>
              </div>

              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn ar-btn mt-4"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6 text-center">
              <img
                src={require("../../../image/Airbnb/choose.webp")}
                alt="Airbnb Clone"
              />
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Developing an Airbnb clone is a lucrative opportunity for
              entrepreneurs looking to enter the vacation rental market. By
              incorporating essential features, leveraging the right technology,
              and implementing strategic marketing, you can build a successful
              Airbnb clone that attracts both hosts and guests. If you are ready
              to launch your own Airbnb clone, contact our expert development
              team today and take the first step toward building a profitable
              online rental marketplace!
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          Can I customize the features of my Airbnb clone?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, you can tailor the Airbnb clone to fit your brand
                          by adding custom features, adjusting design elements,
                          and integrating payment gateways based on your needs.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Time taken to develop an Airbnb clone?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The development time for an Airbnb clone depends on
                          the complexity of features and customization.
                          Typically, it takes anywhere from a few weeks to a few
                          months to launch.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Is it difficult to manage an Airbnb clone platform?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Not at all! Most Airbnb clone solutions come with
                          easy-to-use admin dashboards for managing users,
                          bookings, and payments, making it simple for you to
                          run the platform smoothly.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          Can I integrate multiple payment methods in my Airbnb
                          clone?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, you can integrate various payment gateways like
                          Stripe, PayPal, and Crypto wallets to ensure a smooth
                          transaction process for both guests and hosts.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Airbnb;
